import { Link } from 'react-router-dom';
import { PageShell } from '../components/PageShell.js';

export function NotFoundPage() {
  return (
    <PageShell>
      <section className="card mx-auto max-w-xl text-center">
        <h1 className="heading-xl text-crimson">Page not found</h1>
        <p className="mt-3 text-charcoal">
          This feedback link is no longer available. Please contact FESTIVALSOFINDIASTORE if you
          would still like to share your experience.
        </p>
        <Link className="btn-primary mt-6" to="/">
          Return home
        </Link>
      </section>
    </PageShell>
  );
}
